import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetCancellationReasonsApiResponse , IGetCancellationReasonsPayload } from '../types';

export const getCancellationReasons = async (
  payload?: IGetCancellationReasonsPayload,
): Promise<IGetCancellationReasonsApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetCancellationReasonsApiResponse>(
    '/cancellation-reasons',
    {
      headers,
      params: payload ? { jobType: payload.jobType } : undefined,
    },
  );

  return response.data;
};
